import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './SearchFeature.css';

const SearchFeature = ({ isSearchOpen, searchTerm, setSearchTerm, handleSearch }) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    // Immediately apply or remove the expanded class
    setExpanded(isSearchOpen);
  }, [isSearchOpen]);

  return (
    <div className={`search-container ${expanded ? 'expanded' : ''}`}>
      <input
        type="text"
        className="search-input"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          handleSearch(e.target.value);
        }}
        placeholder="Search..."
      />
      {searchTerm && (
        <button className="clear-button"
        onClick={() => {
            setSearchTerm(''); // Clear the search term
            handleSearch(''); // Ensure search results are updated
          }}>
          <CloseIcon/>
        </button>
      )}
    </div>
  );
};

export default SearchFeature;
